import { Map } from 'immutable';
import { compactSpaces } from '../../../../../utils/helpers/string.helper';

export const manualPaymentMethodTmpl = (
  methodSearchKey: string,
  liDom: any,
  method: Map<string, any>
) => {
  const contents = `
    <p class="method">
      ${method.get(methodSearchKey)}
    </p>
  `;

  liDom.innerHTML = compactSpaces(contents);
};
